export interface BrandColorPreset {
	name: string;
	hex: string;
}

// company_color_code is rendered two ways on printed bills/PDFs
// (invoice-template, sales-book, bill-audit-log): as direct text color on
// white paper, and as a background fill behind hardcoded white text (the
// "Copy of Original" flag, the Grand Total band). A color that's too light
// fails one of those two roles no matter which — so instead of a free-form
// picker, only these pre-vetted colors are offered. Each clears >=4.5:1 WCAG
// contrast against both #ffffff and the app surface tint (#f8f8fc), which
// covers both roles at once.
export const BRAND_COLOR_PRESETS: BrandColorPreset[] = [
	{ name: "Royal Purple", hex: "#523563" },
	{ name: "Midnight Navy", hex: "#1B3A5C" },
	{ name: "Forest Green", hex: "#1E5631" },
	{ name: "Wine Maroon", hex: "#6B1F2A" },
	{ name: "Charcoal Slate", hex: "#33404D" },
	{ name: "Deep Teal", hex: "#0F5C5C" },
	{ name: "Espresso Brown", hex: "#4A2E1F" },
	{ name: "Indigo", hex: "#3B2D6E" },
	{ name: "Burnt Rust", hex: "#8A3B12" },
	{ name: "Steel Blue", hex: "#26547C" },
];
